<template>
    <div
      class="post-thumbs-listing listing-rowed"
      :class="wrapperClasses"
    >
      <ul class="list-wrap">
        <li
          class="list-item"
          v-for="book in books"
          :key="book.id"
        >
          <BookThumbCard
            :book="book"
            @book-destroyed="destroyBook"
          />
        </li>
      </ul>
    </div>
</template>

<script>

import BookThumbCard from '@/components/books/BookThumbCard'

export default {
  name: 'BookThumbList',
  props: ['books', 'itemsPerRow'],
  components: {
    BookThumbCard
  },
  computed: {
    wrapperClasses () {
      return [
        `items-${this.itemsPerRow ? this.itemsPerRow : '3'}-per-row`
      ]
    }
  },
  methods: {
    destroyBook (id) {
      const index = this.books.findIndex(c => c.id === id)
      this.books.splice(index, 1)
      this.$emit('book-destroyed', id)
    }
  }
}
</script>
